/* eslint-disable no-underscore-dangle */
import 'socket.io-client/dist/socket.io';
import config from '../config';

export default {

  install(Vue) {
    const socket = window.io(config.apiUrl !== '/' ? config.apiUrl.replace('http', 'ws') : null,
      {
        path: '/realtime',
        transports: ['websocket', 'polling'],
        transportOptions: {
          polling: {
            extraHeaders: {
              Authorization: 'Bearer abc',
            },
          },
        },
        extraHeaders: {
          Authorization: `Bearer ${localStorage.getItem(`${config.appKey}_token`)}`,
        }
      });

    socket._call = function apiCall(method, event, options) {
      return new Promise((resolve, reject) => {
        socket.emit(event, {
          query: {}, body: {}, headers: {}, ...options, method
        }, (err, data) => {
          if (err) {
            console.error(err);
            reject(err);
          } else {
            resolve(data);
          }
        });
      });
    };

    socket.get = socket._call.bind(undefined, 'GET');
    socket.post = socket._call.bind(undefined, 'POST');
    socket.put = socket._call.bind(undefined, 'PUT');
    socket.delete = socket._call.bind(undefined, 'DELETE');

    socket.onopen((a) => {
      // console.info('[SOCKET] connected', a);
    });

    socket.on('connect', (a) => {
      socket.emit('Authorization', {
        token: localStorage.getItem(`${config.appKey}_token`),
        organisationId: localStorage.getItem(`${config.appKey}_organisationId`),
      });
    });

    socket.on('disconnect', (a) => {
      // eslint-disable-next-line no-console
      console.log('socket reconnecting...');
      socket.connect();
    });

    socket.on('message', (second) => {
    });
    window.socket = socket;
    Vue.prototype.$socket = socket;

    setTimeout(() => {
      socket.connect();
    }, 3000);
  }
};
